import { Controller } from "stimulus";

const CONTACT_DROPDOWN_ID = "screening_order_contact_id";
const API_URL_PREFIX = "/admin/organizations/";
const USER_URL_SUFFIX = "/users";

export default class extends Controller {
  static targets = ["organization"];

  connect() {
    const target = document.querySelector(`#${CONTACT_DROPDOWN_ID}`);
    if (!target.value) {
      this.disableDropdown(CONTACT_DROPDOWN_ID);
    }
  }

  disableDropdown(dropdownId) {
    const target = document.querySelector(`#${dropdownId}`);
    if (target) {
      target.disabled = true;
    }
  }

  enableDropdown(dropdownId) {
    document.querySelector(`#${dropdownId}`).disabled = false;
  }

  organizationDropdownSelected(event) {
    const selectedOrganization = event.target.value;

    this.fetchOrganizationData(
      `${API_URL_PREFIX}${selectedOrganization}${USER_URL_SUFFIX}`,
      CONTACT_DROPDOWN_ID,
      "Select contact",
      "display_name"
    );
  }

  fetchOrganizationData(url, dropdownId, dropdownPlaceholder, displayAttr) {
    $.getJSON(url, (data) => {
      if (data.length > 0) {
        this.enableDropdown(dropdownId);
      } else {
        this.disableDropdown(dropdownId);
      }

      const dropdown = document.querySelector(`#${dropdownId}`);

      // Clean previous organization data & add empty option for placeholder
      dropdown.innerText = "";
      dropdown.add(new Option(dropdownPlaceholder, ""));

      data.forEach((d) => dropdown.add(new Option(d[displayAttr], d.id)));
    });
  }
}
